"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)((0, styles_1.createStyles)({
    wrapper: {
        display: 'block',
        overflow: 'auto',
    },
    tableRoot: {
        borderCollapse: 'separate',
        border: 'none',
        borderSpacing: 0,
        display: 'table',
        width: '100%',
    },
    fixedLayout: {
        tableLayout: 'fixed',
    },
    tbody: {
        display: 'table-header-group',
    },
    footer: {
        paddingTop: 28,
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
    },
    preContent: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginBottom: 28,
        minHeight: 32,
    },
    noResult: {
        textAlign: 'center',
        paddingTop: 90,
        paddingBottom: 62,
    },
    pagination: {
        marginLeft: 'auto',
    },
    clickable: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: "".concat((0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.5), " !important"),
        },
    },
    divider: {
        height: '24px !important',
    },
}));
